import React, { useState } from 'react';
import Logo from "../../Assets/Images/logo.png";
import { Input, notification } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import Loader from '../Loader';
import config, { axiosInstance } from '../Config';
import swal from 'sweetalert';
import AccountContainer from './AccountContainer';

const SignUp = () => {
    const [show_password, setShowPassword] = useState(false);
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("+44-");
    const [experience, setExperience] = useState("");
    const [fullName, setFullName] = useState("");
    const [drivingLicense, setDrivingLicense] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const [Certificate, setCertificate] = useState();
    const [errors, setErrors] = useState({
        fullName: "",
        email: "",
        phone: "",
        experience: "",
        password: "",
        confirmPassword: "",
        drivingLicense: ""
    });

    const navigate = useNavigate();

    const handleValidation = () => {
        let formErrors = {};

        // Validate the form fields
        if (!fullName) {
            formErrors.fullName = "Full Name is required.";
        }
        if (!email) {
            formErrors.email = "Email Address is required.";
        } else {
            const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
            if (!emailRegex.test(email)) {
                formErrors.email = "Please enter a valid email address.";
            }
        }
        if (!phone || phone.length === 4) {
            formErrors.phone = "Phone Number is required.";
        } else if (phone.length < 10) {
            formErrors.phone = "Invalid Phone Number";
        }

        if (!experience) {
            formErrors.experience = "Experience is required.";
        }
        // if (!password) {
        //     formErrors.password = "Password is required.";
        // }
        // if (!confirmPassword) {
        //     formErrors.confirmPassword = "Confirm Password is required.";
        // }
        // if (password !== confirmPassword) {
        //     formErrors.confirmPassword = "Passwords do not match.";
        // }
  
        setErrors(formErrors);
        return Object.keys(formErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault(); 

        // Validate before submitting
        if (handleValidation()) {
            setLoading(true);
            const formData = new FormData();
            formData.append('name', fullName);
            formData.append('email', email);
            formData.append('mobile', phone);
            formData.append('experience', experience);
            // formData.append('password', password);
            if (drivingLicense)
                formData.append('licence', drivingLicense);
            if (Certificate) {
                formData.append("certificate", Certificate);
            }
            formData.append('type', 0)

            try {
                const response = await axiosInstance.post('/instRegister', formData, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "multipart/form-data",
                    }
                });

                if (response.data.success) {
                    notification.open({
                        message: "Registration Successful",
                        description: "Password has been sent to your email.",
                        icon: <i className="icon-check" style={{ color: "#4bb543" }}></i>,
                    });

                    navigate(`${config.appUrl}login`);
                } else {
                    notification.open({
                        message: "Registration Failed",
                        description: "Something went wrong, please try again.",
                        icon: <i className="icon-warning text-danger" style={{ fontSize: "20px" }}></i>,
                    });
                }
            } catch (error) {

                if (error.response.data.message === 'The email has already been taken.') {
                    notification.open({
                        message: "Registration Failed",
                        description: error.response.data.message,
                        icon: <i className="icon-warning text-danger" style={{ fontSize: "20px" }}></i>,
                    });
                    return;
                }

                console.log(error);
                swal("", "Something went wrong!", "error");
            } finally {
                setLoading(false);
            }
        }
    };

    const handleChange = (e) => {
        const value = e.target.value;

        // Ensure the phone number starts with +44 and allow only 10 digits after that
        if (value.startsWith('+44-')) {
            // Allow up to 13 characters (including +44)
            if (value.length <= 14 && /^[0-9]*$/.test(value.substring(4))) {
                setPhone(value);
            }
        } else {
            // If the country code is removed, reset it to +44
            setPhone('+44-');
        }
    };

    return (
        <div>
            {isLoading && (<Loader />)}
            <AccountContainer>
                <form onSubmit={handleSubmit} className='px-md-5'>
                    <div className="ps-form__content px-5 pt-5">
                        <div className='text-center mb-2'>
                            <img src={Logo} alt='No Logo' className='img-fluid w-50' />
                        </div>

                        <h5 className="mt-4 pt-md-4 display-4 fw-semibold text-center mb-2">Create Account</h5>
                        <p className="mb-5 text-center">
                            Sign Up to continue as <span className='text-green'>Instructor</span>
                        </p>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group form-forgot">
                                    <Input
                                        className="form-control form-field"
                                        type="text"
                                        placeholder="Full Name"
                                        value={fullName}
                                        onChange={(e) => setFullName(e.target.value)}
                                    />
                                    {errors.fullName && <div className="text-danger ps-3">* {errors.fullName}</div>}
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="form-group form-forgot">
                                    <Input
                                        className="form-control form-field"
                                        type="email"
                                        placeholder="Email Address"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                    {errors.email && <div className="text-danger ps-3">* {errors.email}</div>}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group form-forgot">
                                    <Input
                                        className="form-control form-field"
                                        type="text"
                                        placeholder="Phone Number"
                                        value={phone}
                                        onChange={handleChange}
                                    />
                                    {errors.phone && <div className="text-danger ps-3">* {errors.phone}</div>}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group form-forgot">
                                    <Input
                                        className="form-control form-field"
                                        type="text"
                                        placeholder="Year of Experience"
                                        value={experience}
                                        onChange={(e) => setExperience(e.target.value)}
                                    />
                                    {errors.experience && <div className="text-danger ps-3">* {errors.experience}</div>}
                                </div>
                            </div>
                            {/* <div className="col-md-6">
                                <div className="form-group form-forgot ">
                                    <div className="position-relative">
                                        <Input
                                            className="form-control form-field"
                                            type={show_password ? "text" : "password"}
                                            placeholder="Create Password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                        <div className="bd-eye-open">
                                            <a onClick={() => setShowPassword(!show_password)}>
                                                <i
                                                    className={show_password ? "icon-eye-crossed" : "icon-eye"}
                                                ></i>
                                            </a>
                                        </div>
                                    </div>
                                    {errors.password && <div className="text-danger ps-3">* {errors.password}</div>}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group form-forgot ">
                                    <div className="position-relative">
                                        <Input
                                            className="form-control form-field"
                                            type={show_password ? "text" : "password"}
                                            placeholder="Confirm Password"
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                        />
                                        <div className="bd-eye-open">
                                            <a onClick={() => setShowPassword(!show_password)}>
                                                <i
                                                    className={show_password ? "icon-eye-crossed" : "icon-eye"}
                                                ></i>
                                            </a>
                                        </div>
                                    </div>
                                    {errors.confirmPassword && <div className="text-danger ps-3">* {errors.confirmPassword}</div>}
                                </div>
                            </div> */}
                            <div className="col-12">
                                <div className="form-group form-forgot">
                                    <label htmlFor="">Upload Driving Licence</label>
                                    <Input
                                        className="form-field "
                                        type="file"
                                        onChange={(e) => setDrivingLicense(e.target.files[0])}
                                    />
                                    {errors.drivingLicense && <div className="text-danger ps-3">* {errors.drivingLicense}</div>}
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="form-group form-forgot">
                                    <label htmlFor="">Upload Instructor Certificate</label>
                                    <Input
                                        className="form-field "
                                        type="file"
                                        onChange={(e) => setCertificate(e.target.files[0])}
                                    />
                                </div>
                            </div>
                            <div className="col-md-12 mt-4 text-center">
                                <button type="submit" className="ps-btn ps-btn--fullwidth btn-green color-white py-4">Sign Up</button>
                            </div>
                            <div className='my-5 text-dark text-center'>
                                Back to
                                <Link to={`${config.appUrl}login`}
                                    className='text-decoration-none text-green'> Login</Link>
                            </div>
                        </div>
                    </div>
                </form>
            </AccountContainer>
        </div>
    );
};

export default SignUp;
